import React from "react";
import Slider from "react-slick";

export default function HealthcareFacility({ data, extraClass = "" }) {
    if (!data) return null;

    const settingskey = {
        autoplay: true,
        speed: 5000,
        autoplaySpeed: 5000,
        infinite: true,
        arrows: false,
        dots: true,
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                },
            },

            {
                breakpoint: 99999,
                settings: "unslick",
            },
        ],
    };


    return (
        <section className={`healthcare-facility ${extraClass}`}>
            <div className="container">
                {data?.title && (
                    <div className="row justify-content-center">
                        <div className="col-md-12 col-lg-8">
                            <div className="facility-text center-heading">
                                <h3 className="heading" dangerouslySetInnerHTML={{ __html: data?.title }} />
                                {data?.description && <p className="sub-heading">{data.description}</p>}
                            </div>
                        </div>
                    </div>
                )}
                {data?.items?.length > 0 && (
                    <Slider {...settingskey} className="key-slides">
                        {data.items.map((item, index) => (
                            <div className="facility-slide" key={index}>
                                <div className="facility-col">
                                    {item?.icon && (<div className="icon">  <img src={item.icon} className="img-responsive" alt="Icon" width={item?.iconWidth || 80} height={item?.iconHeight || 80} loading="lazy" decoding="async" />  </div>)}
                                    {item?.heading && (<div className="heading">  {item.heading}  </div>)}
                                    {item?.description && (<p>{item.description}</p>)}
                                </div>
                            </div>
                        ))}
                    </Slider>
                )}
            </div>
        </section>
    )
}
